import { CerberusStatsFields, PreferencesKeys } from '@hcs/types';

import {
  // MARKET_STATE_CITY_ALL_CHARTS_ORDER,
  MARKET_STATE_MSA_ALL_CHARTS_ORDER,
  MARKET_STATE_ZIP_ALL_CHARTS_ORDER,
} from '../../constants';
import { FieldsType } from '../../hooks';

export const MARKET_STATS_FOR_USER_GEO_TYPE: Record<
  'ZIP' | 'MSA',
  {
    preferenceKey: PreferencesKeys;
    ordering: CerberusStatsFields[];
    chartsType: FieldsType;
  }
> = {
  ZIP: {
    preferenceKey: PreferencesKeys.MarketStateChartsZip,
    ordering: MARKET_STATE_ZIP_ALL_CHARTS_ORDER,
    chartsType: 'chartsZip',
  },
  MSA: {
    preferenceKey: PreferencesKeys.MarketStateChartsMsa,
    ordering: MARKET_STATE_MSA_ALL_CHARTS_ORDER,
    chartsType: 'chartsMsa',
  },
  // CITY: {
  //   // Using the same preference key for city and zip for now
  //   preferenceKey: PreferencesKeys.MarketStateChartsZip,
  //   ordering: MARKET_STATE_CITY_ALL_CHARTS_ORDER,
  //   chartsType: 'chartsCity',
  // },
};
